module.exports = __webpack_public_path__ + "img/addition.29d51c99.svg";